import { PaintedScene } from '../PaintedScene';

export const EMPTY_FIELD_PHASER_KEY = 'EmptyFieldScene' as const;
export const EMPTY_FIELD_MANIFEST_KEY = 's-111-empty-field' as const;

export class EmptyFieldScene extends PaintedScene {
  constructor() {
    super(EMPTY_FIELD_PHASER_KEY, EMPTY_FIELD_MANIFEST_KEY);
  }
}
